import React, {Component} from 'react';
import {connect} from 'react-redux';
import Back from '../../../../components/back';
import {Header} from '../../../components/header';
import Logo from '../../../../components/logo';

class ToolsHeader extends Component {
	constructor(props) {
		super(props);
		this.rightComponent = this.rightComponent.bind(this);
	}
	rightComponent() {
		const { ...headerProps } = this.props;
		const {noBack} = { ...headerProps };
		return (
			<React.Fragment>
				{(noBack) ? '' : <Back noLabel/>}
				<Logo/>
			</React.Fragment>
		);
	}
	render() {
		const {headerData, ...headerProps} = this.props;

		return (	
			<Header RightComponent={this.rightComponent} data={headerData} {...headerProps} />
		)
	}
}

const mapStateToProps = (state) => {
	return {
		headerData: state.Init.data.data || []
	};
};

export default connect(mapStateToProps)(ToolsHeader);